import mixpanel from "mixpanel-browser";
import { OpenInNewWindow } from "../../../../../Helpers/helper";
import { dateTimeFormat } from "../../../../../Helpers/times-ago";
import { Button } from "../../../../../shadcnComponents/ui/button";
import {
  AcceptCollabDialog,
  AccordionFormHeader,
  CollabFormAccordion,
  DeclineCollabDialog,
  ShareDraftDialog,
} from "../BrandCollabComponents/BrandCollabAtomicComponent";
import { ArrowRight, Download, Eye, FileText } from "lucide-react";
import { ToolTipInfo } from "@/Pages/Brand/DashBoard/PromoteAd/Components/Components";
import { useEffect, useState } from "react";
import { useGeneralSettings } from "@/Providers/General";

export const AcceptOpportunityPage = ({
  collab,
  handleSubmit,
  handleAcceptCollab,
  setCurrentStep,
  openAcceptSuccess,
  setOpenAcceptSuccess,
  declineReason,
  setDeclineReason,
  description,
  setDescription,
}) => {
  const generalState = useGeneralSettings();

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference =
        new Date(collab?.expireOn).getTime() - new Date().getTime();

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      }
    };

    // Calculate immediately
    calculateTimeLeft();

    // Update every second
    const timer = setInterval(calculateTimeLeft, 1000);

    // Cleanup
    return () => clearInterval(timer);
  }, [collab?.expireOn]);
  return (
    <>
      {openAcceptSuccess && (
        <ShareDraftDialog
          onClickShareDraft={() => {
            mixpanel.track(
              `Influencer Brand Collab Details  : Share Draft - Visited `
            );
            setOpenAcceptSuccess(false);
            setCurrentStep(2);
          }}
        />
      )}
      <div className="w-full flex flex-col pb-5 gap-4">
        <div className="w-full flex justify-between ">
          <h1 className="text-[color:var(--Shade-White,#FFF)] text-xl not-italic font-bold leading-6 mb-2">
            Brand Deal - Campaign Details
          </h1>
          {collab?.response?.toUpperCase() === "PENDING" && (
            <div className="flex gap-1">
              {timeLeft.days > 0 && (
                <span className="font-bold">{timeLeft.days}d</span>
              )}
              <span className="font-bold">
                {String(timeLeft.hours).padStart(2, "0")}h
              </span>
              <span>:</span>
              <span className="font-bold">
                {String(timeLeft.minutes).padStart(2, "0")}m
              </span>
              <span>:</span>
              <span className="font-bold">
                {String(timeLeft.seconds).padStart(2, "0")}s
              </span>
            </div>
          )}
        </div>

        {/* About Brand */}
        <CollabFormAccordion
          defaultValue="open"
          Header={<AccordionFormHeader title="About Brand" />}
          ContentArray={[
            <>
              <div className="grid grid-cols-2 mt-[20px] ">
                <div className="flex items-start flex-col gap-2">
                  <span className="text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                    Brand name
                  </span>
                  <span className="text-[color:var(--Shade-White,#FFF)] text-sm not-italic font-normal leading-5">
                    {collab?.brandName}
                  </span>
                </div>
                <div className="flex items-start flex-col gap-2">
                  <span className="text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                    Website
                  </span>
                  <span
                    onClick={() =>
                      OpenInNewWindow({ link: collab?.brandWebsite })
                    }
                    className="text-[color:var(--Shade-White,#FFF)] cursor-pointer underline text-sm not-italic font-normal leading-5"
                  >
                    {collab?.brandWebsite}
                  </span>
                </div>
              </div>
            </>,
            <>
              <div className="grid grid-cols-2 mt-[28px] ">
                <div className="flex items-start flex-col gap-2">
                  <span className="text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                    Industry Type
                  </span>
                  <span className="text-[color:var(--Shade-White,#FFF)] text-sm not-italic font-normal leading-5">
                    {collab?.collabInfo?.collabIndustry}
                  </span>
                </div>
                <div className="flex items-start flex-col gap-2">
                  <span className="text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                    Business Model Type
                  </span>
                  <span className="text-[color:var(--Shade-White,#FFF)] text-sm not-italic font-normal leading-5">
                    {collab?.collabInfo?.collabBuisnessType}
                  </span>
                </div>
              </div>
            </>,
          ]}
        />

        {/* Product Information */}
        <CollabFormAccordion
          Header={<AccordionFormHeader title="Product Information" />}
          ContentArray={[
            <>
              <div className="grid grid-cols-2 mt-[20px] ">
                <div className="flex items-start flex-col gap-2">
                  <span className="text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                    Product Name
                  </span>
                  <span className="text-[color:var(--Shade-White,#FFF)] text-sm not-italic font-normal leading-5">
                    {collab?.productInfo?.productName}
                  </span>
                </div>
                {collab?.productInfo?.productLink && (
                  <div className="flex items-start flex-col gap-2">
                    <span className="text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                      Product Reference
                    </span>
                    <span
                      onClick={() =>
                        OpenInNewWindow({
                          link: collab?.productInfo?.productLink,
                        })
                      }
                      className="text-[color:var(--Shade-White,#FFF)] cursor-pointer underline text-sm not-italic font-normal leading-5"
                    >
                      {collab?.productInfo?.productLink || `-`}
                    </span>
                  </div>
                )}
              </div>
            </>,
            <>
              {collab?.productInfo?.productDescription && (
                <div className="flex mt-[32px] ">
                  <div className="flex  items-start flex-col gap-2">
                    <span className="text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                      Product Description
                    </span>
                    <span className="flex  flex-wrap text-[color:var(--Shade-White,#FFF)] text-sm not-italic font-normal leading-5">
                      <div className="ql-snow">
                        <div
                          className="ql-editor"
                          dangerouslySetInnerHTML={{
                            __html: collab?.productInfo?.productDescription,
                          }}
                        />
                      </div>
                    </span>
                  </div>
                </div>
              )}
            </>,
            <>
              {(collab?.postInfo?.postImage?.length > 0 ||
                collab?.postInfo?.postVideo?.length > 0 ||
                collab?.postInfo?.postPdf?.length > 0) && (
                <div className="flex mt-[42px] ">
                  {collab?.postInfo?.postImage?.length > 0 &&
                    collab?.postInfo?.postFormat?.includes("image") > 0 && (
                      <div className="flex items-start flex-col gap-2">
                        <span className="flex gap-1  text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                          Product Images for Campaign{" "}
                          <span className="font-normal">
                            (You can use 1 or many)
                          </span>
                        </span>
                        <div
                          style={{ scrollbarWidth: "none" }}
                          className="flex gap-4 overflow-auto mt-[20px] "
                        >
                          {collab?.postInfo?.postImage?.map(
                            (imageUrl, index) => (
                              <div key={index} className="relative group">
                                <img
                                  src={imageUrl}
                                  alt={`Image ${index + 1}`}
                                  className="w-[325px] h-[178px] object-cover rounded-lg"
                                />
                                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/30 rounded-lg">
                                  <Button
                                    onClick={() =>
                                      generalState?.handleDownloadImage(
                                        imageUrl
                                      )
                                    }
                                    className="bg-white text-black hover:bg-gray-100 flex items-center gap-2"
                                  >
                                    <Download size={16} />
                                    Download
                                  </Button>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}
                  {collab?.postInfo?.postPdf?.length > 0 &&
                    collab?.postInfo?.postFormat?.includes("carousel") > 0 && (
                      <div className="flex items-start flex-col gap-2">
                        <span className="flex gap-1  text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                          Product carousel for Campaign{" "}
                          <span className="font-normal">
                            (You can use 1 or many)
                          </span>
                        </span>
                        <div
                          style={{ scrollbarWidth: "none" }}
                          className="flex gap-4 overflow-auto mt-[20px] "
                        >
                          {collab?.postInfo?.postPdf?.map((pdfUrl, index) => (
                            <PDFPreviewComponent key={index} pdfUrl={pdfUrl} />
                          ))}
                        </div>
                      </div>
                    )}
                  {collab?.postInfo?.postVideo?.length > 0 &&
                    collab?.postInfo?.postFormat?.includes("video") && (
                      <div className="flex items-start flex-col gap-2">
                        <span className="flex gap-1  text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                          Product Video for Campaign{" "}
                        </span>
                        <span
                          onClick={() =>
                            OpenInNewWindow({
                              link: collab?.postInfo?.postVideo,
                            })
                          }
                          className="text-[color:var(--Shade-red,red)] cursor-pointer text-sm not-italic font-normal leading-5"
                        >
                          {collab?.postInfo?.postVideo || `-`}
                        </span>
                      </div>
                    )}
                </div>
              )}
            </>,
          ]}
        />

        {/* Collab requirement */}
        <CollabFormAccordion
          Header={<AccordionFormHeader title="Collab Requirement" />}
          ContentArray={[
            <>
              <div className="grid grid-cols-4 mt-[20px] ">
                <div className="flex items-start flex-col gap-2">
                  <span className="text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                    Post Type
                  </span>
                  <span className="text-[color:var(--Shade-White,#FFF)] text-sm not-italic font-normal leading-5">
                    {collab?.postInfo?.postFormat
                      ?.toUpperCase()
                      ?.replace("/", "+")}
                  </span>
                </div>
                <div className="flex items-start flex-col gap-2">
                  <span className="text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                    {collab?.campaignInfo?.collabType === "fixed"
                      ? "Earnings"
                      : "Earning Estimate"}
                  </span>
                  <span className="text-[color:var(--Shade-White,#FFF)] text-sm not-italic font-normal leading-5">
                    {collab?.campaignInfo?.collabType === "fixed"
                      ? `₹
                    ${new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 2,
                    }).format(collab?.approxPrice)}`
                      : `₹ ${new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        }).format(
                          collab?.minApproxPrice
                        )} - ₹ ${new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        }).format(collab?.approxPrice)}`}
                  </span>
                </div>
                <div className="flex items-start flex-col gap-2">
                  <span className="text-[color:var(--Natural-500,#9E9E9E)]  text-center text-sm not-italic font-semibold leading-5">
                    Campaign Duration{" "}
                  </span>
                  <span className="text-[color:var(--Shade-White,#FFF)] text-sm not-italic font-normal leading-5">
                    5 days
                  </span>
                </div>
                <div className="flex items-start flex-col gap-2">
                  <span className="text-[color:var(--Natural-500,#9E9E9E)] flex gap-1 items-center text-center text-sm not-italic font-semibold leading-5">
                    Expected Start Date{" "}
                    <ToolTipInfo
                      size={12}
                      Content="The final live date will be shared after your draft is approved by the brand"
                    />
                  </span>
                  <span className="text-[color:var(--Shade-White,#FFF)] text-sm not-italic font-normal leading-5">
                    {dateTimeFormat(collab?.campaignInfo?.campaignStartDate)}
                  </span>
                </div>
              </div>
            </>,
            <>
              <div className="flex mt-[32px] ">
                <div className="flex items-start flex-col gap-2">
                  <span className="flex items-center gap-1 text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                    Campaign Draft{" "}
                    <span className="font-normal">(for your reference)</span>
                  </span>
                  <span className="flex flex-wrap text-[color:var(--Shade-White,#FFF)] text-sm not-italic font-normal leading-5">
                    {/* {collab?.postInfo?.postDescription} */}
                    <div className="ql-snow">
                      <div
                        className="ql-editor"
                        dangerouslySetInnerHTML={{
                          __html: collab?.postInfo?.postDescription,
                        }}
                      />
                    </div>
                  </span>
                </div>
              </div>
            </>,
            <>
              <div className="flex mt-[32px] ">
                <div className="flex items-start flex-col gap-2">
                  <span className="text-[color:var(--Natural-500,#9E9E9E)] text-center text-sm not-italic font-semibold leading-5">
                    Guidelines to Follow
                  </span>
                  <span className="flex flex-wrap text-[color:var(--Shade-White,#FFF)] text-sm not-italic font-normal leading-5">
                    <div className="ql-snow">
                      <div
                        className="ql-editor"
                        dangerouslySetInnerHTML={{
                          __html: collab?.postInfo?.postGuidelines,
                        }}
                      />
                    </div>
                  </span>
                </div>
              </div>
            </>,
          ]}
        />

        <div className="flex items-center gap-6 justify-end">
          {collab?.response !== "accepted" && (
            <>
              <DeclineCollabDialog
                declineReason={declineReason}
                setDeclineReason={setDeclineReason}
                description={description}
                setDescription={setDescription}
                Trigger={
                  (!collab?.response ||
                    collab?.response === "pending" ||
                    collab?.response === "") && (
                    <Button
                      onClick={() =>
                        mixpanel.track(
                          `Influencer Brand Collab Details  : Accept Collaborations - Clicked `
                        )
                      }
                      className="bg-transparent"
                      variant="outline"
                    >
                      Decline
                    </Button>
                  )
                }
                onClickDecline={(e) => {
                  mixpanel.track(
                    `Influencer Brand Collab Details  : Decline Collaborations - Submitted `
                  );
                  handleSubmit(e, "rejected");
                }}
              />

              <AcceptCollabDialog
                status={collab?.response}
                TriggerButton={
                  (!collab?.response ||
                    collab?.response === "pending" ||
                    collab?.response === "") && (
                    <Button
                      onClick={() =>
                        mixpanel.track(
                          `Influencer Brand Collab Details  : Accept Collaborations - Clicked `
                        )
                      }
                      variant="destructive"
                    >
                      Accept
                    </Button>
                  )
                }
                onClickAccept={(e, isAccepted) => {
                  mixpanel.track(
                    `Influencer Brand Collab Details  : Accept Collaborations - Submitted `
                  );
                  // handleSubmit(e, "accepted");
                  handleAcceptCollab({
                    e: e,
                    isAccepted: isAccepted,
                    status: "accepted",
                  });
                }}
                collabType={collab?.campaignInfo?.collabType}
              />
            </>
          )}

          {collab?.response === "accepted" && (
            <Button
              onClick={() => {
                mixpanel.track(
                  `Influencer Brand Collab Details  : Share Draft - Visited `
                );
                setCurrentStep(2);
              }}
              variant="destructive"
              className="gap-3 min-w-[180px]"
            >
              Start Writing Draft
              <ArrowRight size={16} />
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

const PDFPreviewComponent = ({ pdfUrl }) => {
  const generalState = useGeneralSettings();
  return (
    <div className="relative group">
      <div className="w-[325px] h-[178px] bg-gray-200 flex items-center justify-center rounded-lg">
        <FileText size={48} className="text-gray-500" />
      </div>

      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/30 rounded-lg">
        <div className="flex gap-2">
          <Button
            onClick={() => OpenInNewWindow({ link: pdfUrl })}
            className="bg-white text-black hover:bg-gray-100 flex items-center gap-2"
          >
            <Eye size={16} />
            Preview
          </Button>
          <Button
            onClick={() => generalState?.handleDownloadPdf(pdfUrl)}
            className="bg-white text-black hover:bg-gray-100 flex items-center gap-2"
          >
            <Download size={16} />
            Download
          </Button>
        </div>
      </div>
    </div>
  );
};
